import Vue from 'vue'

const data = {
  connect: {
    current: '',
    wrapper: "pt:5px!; pb:8px!; mt:5px; absolute; w:100%; radius:8px; border: solid 0.5px #696969; bgc:#272727;",
    item: "font:14px; font-w:500; h:25px; lh:25px; c:#c8c8c8; text-a:c; hover:bgc:#444444!; hover:c:#0ed3ff; cursor:p;",
    list: [
      { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_0" ), is: 1, shit: "", handler: (soce, data) => Object.assign(soce, data) },
      { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_1" ), is: 2, shit: "", handler: (soce, data) => Object.assign(soce, data) }
    ],
    handler (soce, data) {
      Object.assign(soce, data)
      return soce.current
    },
    title: {
      label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_2" ),
      shit: "font:12px; h:12px; lh:12px; c:#c8c8c8; mb:5px; ml:12px;"
    }
  },
  connected: {
    set: {
      current: '',
      wrapper: "pt:5px!; pb:8px!; mt:5px; absolute; w:100%; radius:8px; border: solid 0.5px #696969; bgc:#272727;",
      item: "font:14px; font-w:500; h:25px; lh:25px; c:#c8c8c8; text-a:c; hover:bgc:#444444!; hover:c:#0ed3ff; cursor:p;",
      list: [
        { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_3" ), is: 1, shit: "" },
        { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_4" ), is: 2, shit: "" }
      ],
      handler (soce, data) {
        Object.assign(soce, data)
        return soce.current
      },
      title: {
        label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_5" ),
        shit: "font:12px; h:12px; lh:12px; c:#c8c8c8; mb:5px; ml:12px;"
      }
    },
    seted: {
      current: '',
      wrapper: "pt:5px!; pb:8px!; mt:5px; absolute; w:100%; radius:8px; border: solid 0.5px #696969; bgc:#272727;",
      item: "font:14px; font-w:500; h:22px; lh:22px; c:#c8c8c8; text-a:c; hover:bgc:#444444!; hover:c:#0ed3ff; cursor:p;",
      list: [
        { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_6" ), is: 1, shit: "" },
        { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_7" ), is: 2, shit: "" }
      ],
      handler (soce, data) {
        Object.assign(soce, data)
        return soce.current
      },
      title: {
        label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_8" ),
        shit: "font:12px; h:32px; lh:32px; c:#c8c8c8; ml:20px;"
      },
      robot: {
        label: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_9"),
        shit: 'font:12px; letter-s:0.57px; lh:1.2; ml:37px; font-w:500; c:#29bde5; mb:10px;'
      },
      collapse: [{
        show: true,
        index: 0,
        icon: {
          href: 'el-icon-caret-top',
          shit: 'font:20px; vertical-a:m; absolute; top:6px; left:15.7px;'
        },
        title: {
          label: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_10"),
          shit: 'cursor:p; hover:bgc:#444444!; h:32px; font:12px; letter-s:0.69px; c:#c8c8c8; lh:32px; relative; pl:37px;',
          handler (obj) { this.$emit('interfaceEvent', obj) }
        },
        item: 'cursor:p; c:#a8a8ac; letter-s:0.7px; h:40px; lh:40px; font:14px; hover:bgc:#444444!; pl:37px;',
        current: '',
        list: [
          { emitKey: 'collapse.0.list.0.svg', is: 1, shit: '', 
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_11"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data)},
            },
            svg: { width: 16, height: 16, common: '#t-code-connect-stopVoice-nomal', current: '', normal: '', active: '#t-code-connect-stopVoice-active',
              handler: (soce, data) => Object.assign(soce, data)}},
          { emitKey: 'collapse.0.list.1.svg', is: 2, shit: '',
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_12"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data) } },
            svg: { width: 16, height: 16, common: '#t-code-connect-stopVoice-nomal', current: '', normal: '', active: '#t-code-connect-stopVoice-active',
              handler: (soce, data) => Object.assign(soce, data)
            }},
          { emitKey: 'collapse.0.list.2.svg', is: 3, shit: '',
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_13"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data)
            }},
            svg: { width: 16, height: 16, common: '#t-code-connect-stopVoice-nomal', current: '', normal: '', active: '#t-code-connect-stopVoice-active',
              handler: (soce, data) => Object.assign(soce, data)
          },},
        ],
        handler (soce, data, store) {
          soce.list.forEach(o => {
            o.label.shit.current = ''
            o.svg.current = ''
          })
          window.l$(soce, data, 'handler', store)
          Object.assign(soce, data)
          store.commit('pop/stopVoice', data.current)
        }
      }, {
        show: true,
        index: 1,
        current: '',
        icon: {
          href: 'el-icon-caret-top',
          shit: 'font:20px; vertical-a:m; absolute; top:6px; left:15.7px;'
        },
        title: {
          label: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_14"),
          shit: 'cursor:p; hover:bgc:#444444!; h:32px; font:12px; letter-s:0.69px; c:#c8c8c8; lh:32px; relative; pl:37px;',
          handler (obj) { this.$emit('interfaceEvent', obj) }
        },
        item: 'cursor:p; c:#a8a8ac; letter-s:0.7px; h:40px; lh:40px; font:14px; hover:bgc:#444444!; pl:37px;',
        list: [
          { emitKey: 'collapse.1.list.0.svg', is: 1, shit: '',
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_15"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data) } },
            svg: { width: 16, height: 16, common: '#t-code-connect-stopScript-nomal', current: '', normal: '', active: '#t-code-connect-stopScript-active',
              handler: (soce, data) => Object.assign(soce, data) },},
          { emitKey: 'collapse.1.list.1.svg', is: 2, shit: '',
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_16"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data) } },
            svg: { width: 16, height: 16, common: '#t-code-connect-stopScript-nomal', current: '', normal: '', active: '#t-code-connect-stopScript-active',
              handler: (soce, data) => Object.assign(soce, data) },},
          { emitKey: 'collapse.1.list.2.svg', is: 3, shit: '',
            label: { text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/pop.js_17"),
              shit: { common: 'ml:10px;', noraml: '', active: 'c:#fff!;', current: '',
                handler: (soce, data) => Object.assign(soce, data) } },
            svg: { width: 16, height: 16, common: '#t-code-connect-stopScript-nomal', current: '', normal: '', active: '#t-code-connect-stopScript-active',
              handler: (soce, data) => Object.assign(soce, data) },},
        ],
        handler (soce, data, store) {
          soce.list.forEach(o => {
            o.label.shit.current = ''
            o.svg.current = ''
          })
          Object.assign(soce, data)
          store.commit('pop/stopCode', data.current)
        }
      },]
    },
  },
  quickConnected: {
    normal: {
      current: '',
      wrapper: "mt:5px; absolute; w:100%; radius:8px; border: solid 0.5px #696969; bgc:#272727; pt:5px; pb:15px;",
      item: "font:14px; font-w:500; h:30px; lh:30px;  c:#c8c8c8; text-a:c; after:content:''; after:h:1px; after:bgc:#696969; after:mt:7px; after:dis:block; hover:bgc:#444444!; hover:c:#0ed3ff; cursor:p; mb:7px;", // radius:8px;
      list: [
        { label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_18" ), is: 2, shit: "" }
      ],
      handler (soce, data) {
        Object.assign(soce, data)
        return soce.current
      },
      title: {
        label: Vue.prototype.$t( "code-lab/component/robot-connect/device-manage/observable/pop.js_19" ),
        shit: "font:12px; h:12px; lh:12px; c:#c8c8c8; mb:5px; ml:12px;"
      }
    },
  },
  quickConnect: {
    normal: {}
  },
  stopCode: '',
  stopVoice: '',
  switchIs: false,
  connectPopStatus: 'connect',
}

export const state = Vue.observable(data)

export const mutations = {
    switchIs (state, payload) {
      window.l$(state, payload)
      Object.assign(state, payload)
    },
    connectPopStatus (state, payload) {
      window.l$(state, payload, 'connectPopStatus')
      Object.assign(state, payload)
    },
    'connected.seted.robot' (state, payload) {
      window.l$(state, payload, 'connected.seted.robot')
      Object.assign(state.connected.seted.robot, payload)
    },
    stopCode (state, payload) {
      Object.assign(state, { stopCode: payload })
    },
    stopVoice (state, payload) {
      Object.assign(state, { stopVoice: payload })
    },


    clearValOfStopCodeList (state) {
      const list = state.connected.seted.collapse[1].list.map(item => {
        item.svg.current = ''
        item.label.shit.current = ''
        return item
      })
      Object.assign(state.connected.seted.collapse[1], { list })
    },
    clearOfStopCode (state) {
      Object.assign(state, { stopCode: '' })
    },
    clearOfStopCodeCurrent (state) {
      const data = state.connected.seted.collapse[1]
      Object.assign(data, { current: '' })
    },
}

export const module =  {
    namespaced: true,
    state,
    mutations
} 
